import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TABLET_TYPE_OPTIONS } from '@app/shared/constants/kit-selector-options';

export type TabletType = 'buy' | 'rent' | 'free' | undefined;

@Component({
    selector: 'app-tablet-option',
    templateUrl: './tablet-option.component.html',
    styleUrls: ['./tablet-option.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabletOptionComponent {
    readonly tabletTypeOptions = TABLET_TYPE_OPTIONS;

    @Input() withTablet = false;
    @Input() withSimCard = false;
    @Input() tabletType: TabletType = undefined;
    @Input() invalid = false;
    @Input() disabled = false;
    @Input() showCheckbox = true;
    @Input() idPrefix = 'tablet';

    @Output() withTabletChange = new EventEmitter<boolean>();
    @Output() tabletTypeChange = new EventEmitter<TabletType>();
    @Output() withSimCardChange = new EventEmitter<boolean>();
    @Output() selectionChange = new EventEmitter<void>();

    onWithTabletChange(withTablet: boolean): void {
        const tabletType = withTablet ? 'rent' : undefined;
        const withSimCard = withTablet ? (this.withSimCard ?? false) : false;

        this.withTabletChange.emit(withTablet);
        this.tabletTypeChange.emit(tabletType);
        this.withSimCardChange.emit(withSimCard);
        this.selectionChange.emit();
    }

    onTabletTypeChange(tabletType: TabletType): void {
        this.tabletTypeChange.emit(tabletType);
        this.selectionChange.emit();
    }

    onWithSimCardChange(withSimCard: boolean): void {
        this.withSimCardChange.emit(withSimCard);
        this.selectionChange.emit();
    }
}
